import { useQuery } from "@tanstack/react-query";
import ConfigHolder from "../../config/ConfigHolder";
import { apiSign } from "../../context/WidgetContext";
import useWidgetStore from "../../store/useWidgetStore";
import { useSettings } from "../../context/SettingsContext";
export const usePreValidateConsumer = (formContext, options) => {
    const { api_key, widget_id } = useSettings();
    const { language } = useWidgetStore();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: false, networkMode: "always", cacheTime: 0, staleTime: 0 });
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-pre-validate-consumer'], queryFn: async ({ signal }) => {
            var _a, _b, _c, _d;
            let url = new URL('/consumer/booking/api/method/preValidateCustomer', ConfigHolder.apiBaseUrl);
            const data = {
                email: formContext.getValues('email'),
            };
            let api_salt = Date.now(), body = new URLSearchParams(data);
            let _params = Object.assign(Object.assign({}, data), { applicationId: (_b = (_a = process.env) === null || _a === void 0 ? void 0 : _a.YII_API_APPLICATION_ID) !== null && _b !== void 0 ? _b : 'widget-booking', method: 'preValidateCustomer', widget_id: widget_id });
            url.searchParams.set('api_signature', apiSign(_params, api_key, api_salt));
            url.searchParams.set('api_format', 'json');
            url.searchParams.set('api_lang', language);
            url.searchParams.set('api_salt', api_salt.toString());
            url.searchParams.set('applicationId', (_d = (_c = process.env) === null || _c === void 0 ? void 0 : _c.YII_API_APPLICATION_ID) !== null && _d !== void 0 ? _d : 'widget-booking');
            url.searchParams.set('api_key', api_key);
            url.searchParams.set('widget_id', widget_id);
            const response = await fetch(url.href, {
                signal: signal,
                method: "POST", // this request is GET in the old widget
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'X-OAnl-csrf-protection': 'on',
                    'accept': 'application/ld+json',
                },
                body: body
            });
            return response.json();
        } }));
};
